import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { SuppliersListWrapper } from './suppliers-list/SuppliersList'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'

const suppliersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Supplier Management',
    path: '/admin/pages/suppliers',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/suppliers/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const SuppliersPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='suppliers'
          index
          element={
            <>
              <PageTitle breadcrumbs={suppliersBreadcrumbs}>Suppliers list</PageTitle>
              <SuppliersListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/suppliers/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/suppliers' />} />
    </Routes>
  )
}

export default SuppliersPage
